<template>
  <v-layout mt-4 child-flex>
    <v-flex xs12>
      <products-table
        :key="updateIndex"
        :headers="productTableHeaders"
        :actions="productTableActions"
        :can-add-products="canAddProducts"
      />
    </v-flex>
    <edit-product-modal
      v-if="editProductModal"
      :product="editProduct"
      title="Edit Product"
      @save="saveProduct"
      :editProductModal.sync="editProductModal"
    />
    <confirm-action-modal
      v-if="confirmActionModal"
      text="Are you sure you want to delete this product? This action CANNOT be undone!"
      title="Delete Product"
      @confirm="archiveProduct"
      :confirmActionModal.sync="confirmActionModal"
    />
  </v-layout>
</template>

<script>
import request from "@/modules/request";
import Table from "@/components/Table";
import EditProductModal from "@/components/shared/modals/EditProductModal";
import ConfirmActionModal from "@/components/shared/modals/ConfirmActionModal";
import { hasPermission } from "@/modules/rbac/permission-manifest";
import ProductsTable from "@/components/ProductsTable";

export default {
  name: "Products",
  inject: ["snackBar", "reactiveInjected"],
  props: {
    canAddProducts: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.setProductTableActions();
  },
  components: {
    EditProductModal,
    ConfirmActionModal,
    ProductsTable,
  },
  data() {
    return {
      updateIndex: 0,
      loading: false,
      productTableHeaders: [
        {
          text: "Product ID",
          value: "productCode",
          width: "15%",
        },
        {
          text: "Manufacturer",
          value: "manufacturer",
        },
        {
          text: "Category",
          value: "category.name",
        },
        {
          text: "Description",
          value: "description[0].value",
          width: "25%",
        },
        {
          text: "Cost",
          value: "invoicePrice",
        },
        {
          text: "",
          value: "action",
          sortable: false,
          width: "20%",
        },
      ],
      productTableActions: [],
      editProductModal: false,
      editProduct: undefined,
      deleteProduct: undefined,
      confirmActionModal: false,
      canCreateProduct: hasPermission(
        "canCreateProduct",
        null,
        this.reactiveInjected.activeUser
      ),
      canUpdateProduct: hasPermission(
        "canUpdateProduct",
        null,
        this.reactiveInjected.activeUser
      ),
      canDeleteProduct: hasPermission(
        "canDeleteProduct",
        null,
        this.reactiveInjected.activeUser
      ),
    };
  },
  methods: {
    gotoNewProduct() {
      this.$router.push({
        name: "AddProduct",
      });
    },
    setProductTableActions() {
      if (this.canUpdateProduct) {
        this.productTableActions.push({
          color: "primary",
          click: this.setEditProduct,
          text: "",
          icon: "edit",
        });
      }

      if (this.canDeleteProduct) {
        this.productTableActions.push({
          color: "error",
          click: this.setDeleteModal,
          text: "",
          icon: "delete_forever",
        });
      }
    },
    setEditProduct(product) {
      this.editProduct = product;
      this.editProductModal = true;
    },
    setDeleteModal(product) {
      this.deleteProduct = product;
      this.confirmActionModal = true;
    },
    saveProduct(context) {
      const { product, newFields } = context;
      request
        .callInternal({
          method: "patch",
          route: `/api/admin/product/${product._id}`,
          data: {
            product,
            newFields,
          },
        })
        .then((results) => {
          this.$swal({
            title: "Congratulations!",
            text: `Your new product was successfully saved.`,
            icon: "success",
          });
          this.editProduct = undefined;
          this.editProductModal = false;
        })
        .catch((error) => {
          console.error(error);
          // TODO - improve error handling (in general)
          this.$swal({
            title: "Error",
            text:
              "Something went wrong with saving this product. Please make sure the Product Code is unique and try again",
            icon: "error",
          });
        });
    },
    archiveProduct() {
      request
        .callInternal({
          method: "delete",
          route: `/api/admin/product/${this.deleteProduct._id}`,
        })
        .then((results) => {
          this.$swal({
            title: "Congratulations!",
            text: `Your new product was successfully deleted.`,
            icon: "success",
          });
          this.confirmActionModal = false;
          this.deleteProduct = undefined;
          this.updateIndex += 1;
        })
        .catch((error) => {
          console.error(error);
          // TODO - improve error handling (in general)
          this.$swal({
            title: "Error",
            text:
              "Something went wrong with deleting this product. Please try again",
            icon: "error",
          });
        });
    },
  },
};
</script>
